const About = () => {
  return (
    <section className='py-32 relative'>
      <div className='container mx-auto px-8 max-w-7xl'>
        <h2 className='section-title'>
          О нас
        </h2>
        <p className='text-xl text-gray-600 dark:text-gray-400 mb-8'>
          HiSphere — небольшая команда разработчиков, которая делает конкретные продукты, а не обещания. Сейчас это связь (ConnectMe), архивация файлов (HiZip) и тренировки (Vithenics) — три разных задачи, три разных приложения.
        </p>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          <div className='glass-card p-6 rounded-2xl'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Как мы работаем</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Без долгих согласований и лишних прослоек: от идеи до релиза продукт проходит через одну и ту же небольшую команду, поэтому решения принимаются быстро.
            </p>
          </div>
          <div className='glass-card p-6 rounded-2xl'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Чем занимаемся</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Пишем и поддерживаем свои продукты сами — от бэкенда до интерфейса — и развиваем их по фидбэку от реальных пользователей.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
